import { state } from 'cerebral/tags'
import { set } from 'cerebral/operators'
import loadOrderHistory from './loadOrderHistory'

export default [
  set(state`orderHistory.assignedTo`, null),
  set(state`orderHistory.statuses`, ['CLOSED', 'PROCESSING', 'FAILED']),
  ...loadOrderHistory
]



// WEBPACK FOOTER //
// ./src/modules/OrderHistory/chains/loadForAllUsersOrderHistory.js